<c-full-page-layout [hasFooter]="true">
  <div full-page-header>
    <div class="sign-document-verification__header">
      <c-button
        type="secondary"
        [iconOnly]="true"
        [icon]="backIcon"
        [ariaLabel]="'common.back' | transloco"
        (action)="back()" />

      <h1 class="sign-document-verification__title">
        {{ 'my-documents.sign-batch.verify.title' | transloco }}
      </h1>

      <c-button
        type="secondary"
        [iconOnly]="true"
        [icon]="closeIcon"
        [ariaLabel]="'common.close' | transloco"
        (action)="close()" />
    </div>
  </div>

  <div full-page-content>
    <div class="sign-document-verification__content">
      <p class="sign-document-verification__text">
          {{ 'my-documents.sign-batch.verify.text' | transloco: { phoneNumber: maskedPhone() } }}
      </p>

      <p class="sign-document-verification__hint">
        {{ 'my-documents.sign-batch.verify.hint' | transloco }}
      </p>

      <form [formGroup]="verificationCodeForm" class="sign-document-verification__form">
        <c-code-verification
          formControlName="verificationCode"
          [otpLength]="otpLength()"
          [inputStyles]="otpInputStyles"
          (sendVerificationCode)="resend()" />
      </form>
    </div>
  </div>

  <div full-page-footer>
    <div class="sign-document-verification__footer">
      <c-button
        [loading]="loading()"
        [disabled]="disableVerify()"
        (action)="verify()">
        {{ 'my-documents.sign-batch.verify.cta' | transloco }}
      </c-button>
    </div>
  </div>
</c-full-page-layout>
